import { Button, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const ConfirmWithTemplates = props => {
  const { addFile, fileSchemaName, linkedTemplates } = props;
  const templatesText = linkedTemplates.map(d => `${d.resourceType} (${d.namespace})`).join(', ');
  return (
    <div style={{ textAlign: 'center' }}>
      <Descriptions style={{ marginTop: 20 }} bordered column={1} title="New Mapping">
        <Descriptions.Item label="File Schema Name">{fileSchemaName}</Descriptions.Item>
        <Descriptions.Item label="Templates">{templatesText}</Descriptions.Item>
      </Descriptions>
      <Button style={{ marginTop: 20 }} type="primary" onClick={() => addFile()}>
        Confirm
      </Button>
    </div>
  );
};

ConfirmWithTemplates.propTypes = {
  addFile: PropTypes.func.isRequired,
  fileSchemaName: PropTypes.string.isRequired,
  linkedTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      namespace: PropTypes.string,
      resourceType: PropTypes.string,
    }),
  ).isRequired,
};

export default ConfirmWithTemplates;
